import {Button, Form, Input, Select} from "antd";
import {xcService} from "../../../_services/xcService";
import {useEffect, useState} from "react";

const ResourceAdminView = ({setShowModal}) => {
    const [provinceList, setProvinceList] = useState();
    const [areasList, setAreasList] = useState();
    const [coursesList, setCoursesList] = useState();
    const [rolesList, setRolesList] = useState();
    const [selectedDegree, setSelectedDegree] = useState();
    const [selectedFamily,setSelectedFamily] = useState();

    useEffect(()=>{
       xcService.get('/v1/provinces').then(({data})=> setProvinceList(data.data));
       xcService.get('/v1/areas').then(({data})=> setAreasList(data.data.filter(area=>area.assessments[0].questionnaire_id===1)));
       xcService.getToken('/v1/degrees').then(({data})=> setCoursesList(data.data));
       xcService.get('/v1/roles').then(({data})=> setRolesList(data.data));
    },[])

    const onFinish = (values) => {
        xcService.postToken('/v1/resources', values)
            .then(({data})=>data.data.id)
            .then((id)=>{
                if(values.area) xcService.postToken("/v1/resources/area", {
                    areaId: values.area,
                    userLinkId: id
                })
                if(values.province) xcService.postToken("/v1/resources/region", {
                    userLinkId: id,
                    regionId: values.province
                })
                if(values.course) xcService.postToken("/v1/resources/title", {
                    userLinkId: id,
                    titleId: values.course
                })
                setShowModal(false)
            })
    }
    return (
        <>
            <div className={"container container--resources boxed boxed--admin-default"}>
        <Form onFinish={onFinish}>
            <Form.Item
                label="Nombre"
                name="name"
                rules={[{ required: true, message: 'Please input your username!' }]}
            ><Input/></Form.Item>
            <Form.Item
                label="Descripción"
                name="description"
                rules={[{ required: true, message: 'Please input your username!' }]}
            ><Input/></Form.Item>
            <Form.Item
                label="Url"
                name="url"
                rules={[{ required: true, message: 'Please input your username!' }]}
            ><Input/></Form.Item>
            <Form.Item
                label="Región"
                name="province">
                <Select mode="multiple">
                    {provinceList&&provinceList.map(province=><Select.Option value={province.id}>{province.name}</Select.Option>)}
                </Select>
            </Form.Item>
            <Form.Item
                label="Area"
                name="area">
                <Select mode="multiple">
                    {areasList&&areasList.map(area=><Select.Option value={area.id}>{area.name}</Select.Option>)}
                </Select>
            </Form.Item>
            <Form.Item
                label="Estudios">
                <Select onSelect={setSelectedDegree}>
                    {coursesList&&coursesList.filter((value, index, self) => {
                        return self.findIndex(v => v.degreeId === value.degreeId) === index;
                    }).map(course=><Select.Option value={course.degreeId}>{course.name}</Select.Option>)}
                </Select>
            </Form.Item>
            {selectedDegree&&<Form.Item
                label="Familia">
                <Select onSelect={setSelectedFamily}>
                    {selectedDegree && coursesList.filter((course=>course.degreeId===selectedDegree))
                        .filter((value, index, self) => {
                            return self.findIndex(v => v.family === value.family) === index;
                        })
                        .map(course => <Select.Option value={course.family}>{course.family}</Select.Option>)}
                </Select>
            </Form.Item>}
            {selectedFamily&&<Form.Item
                label="Titulación"
                name="course">
                <Select>
                    {selectedDegree && coursesList.filter((course=>course.family===selectedFamily))
                        .map(course => <Select.Option value={course.familyId}>{course.title}</Select.Option>)}
                </Select>
            </Form.Item>}
            <Form.Item
                label="Rol"
                name="role">
                <Select mode="multiple">
                    {rolesList&&rolesList.map(role=><Select.Option value={role.id}>{role.role}</Select.Option>)}
                </Select>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                    Crear recurso
                </Button>
            </Form.Item>
        </Form></div></>
    )
}

export default ResourceAdminView;
